export default __webpack_public_path__ + "static/media/info-centre.39381234.svg";